import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SidenavService {
  private sidenav!: MatSidenav;
  public hasToggled = false;
  private readonly activitySubject = new BehaviorSubject<void>(undefined);
  readonly activity$ = this.activitySubject.asObservable();

  public setSidenav(sidenav: MatSidenav) {
    this.sidenav = sidenav;
  }

  public open() {
    this.activitySubject.next();
    return this.sidenav.open();
  }

  public close() {
    this.activitySubject.next();
    return this.sidenav.close();
  }

  public toggle(): void {
    this.activitySubject.next();
    this.hasToggled = true;
    this.sidenav.toggle();
  }
}
